import Vue from 'vue/dist/vue.esm'

Vue.component('calendars-main-vue', () => import(/* webpackChunkName: "[request]" */ 'components/calendars/Main')),
Vue.component('sofia-file-uploader-vue', () => import(/* webpackChunkName: "[request]" */ 'components/sofia/FileUploader')),
Vue.component('access-services-vue', () => import(/* webpackChunkName: "[request]" */ 'components/AccessServices'))
Vue.component('commercial-contact-form-vue', () => import(/* webpackChunkName: "[request]" */ 'components/CommercialContactForm'))
Vue.component('layout-collapsable-panel-vue', () => import(/* webpackChunkName: "[request]" */ 'components/layout/CollapsablePanel'))
Vue.component('tirant-prime-conversa-vue', () => import(/* webpackChunkName: "[request]" */ 'components/conversa/TirantPrimeConversa'))
Vue.component('conversa-button-vue', () => import(/* webpackChunkName: "[request]" */ 'components/conversa/ConversaButton'))
Vue.component('home-advertising-vue', () => import(
  /* webpackChunkName: "[request]" */ 'components/HomeAdvertising'
))
